export enum DateFormat {
  hourly = 1,
  daily = 2,
  weekly = 3,
  monthly = 4,
}
